class TouchDetectionService {
    constructor() {
        if (
            window.matchMedia("(pointer: coarse)").matches ||
            navigator.maxTouchPoints > 0 ||
            "ontouchstart" in window ||
            (window.DocumentTouch && document instanceof window.DocumentTouch)
        ) {
            document.querySelector("html").classList.add("mobile");
        } else {
            document.querySelector("html").classList.add("desktop");
        }
    }
}

export default TouchDetectionService;
